import React from 'react';
import { Layout, Menu} from 'antd';
import {Link} from 'react-router-dom';
import {
    FileTextOutlined
} from '@ant-design/icons';

const {
    Header, Content, Sider
} = Layout;

class Main extends React.Component{
    static STATE_STRUCT = () => {
        return {

        }
    };

    state = Main.STATE_STRUCT();

    componentDidMount() {
        if (!localStorage.isLogin) {
            this.props.history.push('/login');
        }
    }

    render() {
        const {
            history
        } = this.props;

        return (
            <Layout>
                <Header className="header" style={{paddingLeft:'10px'}}>
                    <div style={{float:'right', color: 'white'}}>
                        <span style={{marginRight:'10px'}}>管理员</span>
                        <a onClick={()=>{localStorage.removeItem("isLogin");history.push('/login');}} style={{color:'#fff'}}><span>退出登录</span></a>
                    </div>
                </Header>
                <Layout>
                    <Sider>
                        <Menu
                            mode="inline"
                            defaultSelectedKeys={['1']}
                            style={{height: '100%', borderRight: 0 }}>
                            <Menu.Item key="1">
                                <Link to='/news'>
                                    <FileTextOutlined />
                                    <span>新闻管理</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="2">
                                <Link to='/qa'>
                                    <FileTextOutlined />
                                    <span>Qa管理</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="3">
                                <Link to='/case'>
                                    <FileTextOutlined />
                                    <span>例子管理</span>
                                </Link>
                            </Menu.Item>
                        </Menu>
                    </Sider>
                    <Content style={{padding: 20, background: "white"}}>
                        {this.props.children}
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export default Main;
